<template>
	<div v-if="!url" class="img-loading-hack">
		 <div class="loading-progress-btn" v-if="!url"></div>
	</div>
	
	<img :src="url" v-else-if="url"  />

</template>
<script>
	export default{
		name:'img-loader',

		props:{
			imgUrl:{
				type:String,
				default:''
			},
			defaultImgUrl:{
				type:String,
				default:''
			}
		},
		data(){
			return{
				url:''
			}
		},
		watch:{
			imgUrl(){
				this.initData();
			}
		},
		methods:{
			initData(){
				var that=this;
				that.loadImg(that.imgUrl).then((img)=>{
					that.url=img.src;
				}).catch(()=>{
					// that.url=that.defaultImgUrl;
					that.url='./../../../assets/img/defaultHotel.jpg';
				})

			},
			loadImg(image){
				if(!image||image==undefined){
					return Promise.reject();
				}else if (typeof image === 'string') {
					const src = image;
					image = new Image();
					image.src = src;
				}

				const promise = new Promise((resolve, reject) => {
					if (image.naturalWidth) {
						resolve(image);
					} else if (image.complete) {
						reject(image);
					} else {
						image.addEventListener('load', fullfill);
						image.addEventListener('error', fullfill);
					}
					function fullfill() {
						if (image.naturalWidth) {
							resolve(image);
						} else {
							reject(image);
						}
						image.removeEventListener('load', fullfill);
						image.removeEventListener('error', fullfill);
					}
				});
				promise.image = image;
				return promise;
			}
		},
		mounted(){
			this.initData();
		}
	}
</script>










// WEBPACK FOOTER //
// src/common/cmpnt/imgLoader/imgLoader.vue